import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '../../../core/Button';
var defaultStyle = {
  backgroundColor: 'orange',
  color: 'rgba(0, 0, 0, 0.87)',
  fontSize: '12px',
  paddingTop: '0px',
  paddingBottom: '0px',
  minWidth: 'auto',
  borderRadius: 8
};

var TrialBadge = function TrialBadge(_ref) {
  var tooltip = _ref.tooltip,
      useRightMargin = _ref.useRightMargin,
      onClick = _ref.onClick;

  var style = _objectSpread({}, defaultStyle, {
    marginRight: useRightMargin ? 16 : 0
  });

  return React.createElement(Tooltip, {
    title: tooltip,
    placement: "left-start"
  }, React.createElement(Button, {
    onClick: onClick,
    size: "small",
    style: style
  }, "Trial"));
};

TrialBadge.defaultProps = {
  tooltip: 'The app runs in trial mode',
  useRightMargin: false
};
export default TrialBadge;